import MuiCard from '@mui/material/Card';
import { styled } from '@mui/material/styles';

const Card = styled(MuiCard)(({ theme }) => ({
  borderRadius: '10px',
  [theme.breakpoints.down('sm')]: { background: '#f5f5f5' },
}));

export default Card;
